import CountryList from "../../slices/demographics/CountryList";
import StateByCountry from "../../slices/demographics/StateByCountry";
import CityByState from "../../slices/demographics/CityByState";
import CityList from "../../slices/demographics/CityList";

const demographicsReducer = {
    countryList: CountryList,
    stateByCountry: StateByCountry,
    cityByState: CityByState,
    cityList: CityList,
};

export default demographicsReducer;